(() => {
  'use strict';
  // PATAGONIA — reconnaissance d'un client déjà venu, 27-10.
  // Chargé avant pc-mobile-2710.js, il pose le témoin dans le stockage local
  // à partir des trois signaux possibles, du plus fiable au moins fiable :
  //  1. client connecté qui a déjà commandé (drapeau posé par Liquid)
  //  2. cookie pcm27_client déposé à la fin du paiement par le pixel Shopify
  //  3. retour sur le site par un lien de nos e-mails portant ?pc=client
  function remember() {
    try { localStorage.setItem('pcm27-client', '1'); } catch (e) {}
  }
  function run() {
    const flag = document.getElementById('pcm27-client');
    if (flag) {
      try { if (JSON.parse(flag.textContent).known === true) { remember(); return; } } catch (e) {}
    }
    if (document.cookie.indexOf('pcm27_client=1') !== -1) { remember(); return; }
    try {
      if (new URLSearchParams(window.location.search).get('pc') === 'client') { remember(); }
    } catch (e) {}
  }
  run();
})();